<!---->
<template>
  <el-form
    ref="form"
    v-bind="$attrs"
    :label-position="labelPosition"
    @submit.native.prevent
  >
    <slot />
  </el-form>
</template>

<script>
const methods = [
  'validate',
  'validateField',
  'resetFields',
  'toggleRowExpansion',
  'clearValidate'
];
export default {
  name: 'RtForm',
  data() {
    return {
      labelPosition: 'top'
    };
  },
  mounted() {
    this.$nextTick(() => {
      // 将 elementui form 组件原生方法附加在 rtFrom 上面
      methods.map(method => {
        this[method] = this.$refs.form[method];
      });
    });
  }
};
</script>



// WEBPACK FOOTER //
// rtForm.vue?367e0888